import React from "react";
import { Modal, Text, TouchableOpacity, View } from "react-native";
import PremiMultimedia from "../Premi/PremiMultimedia";
import style from "./style";

//todo introduir traduccións al nom del premi
function PopUpPerfilImatge(premi, modalVisible, setModalVisible, idioma, poiData) {
  if (!premi || !modalVisible) {
    return null;
  }
  
  return (
    <TouchableOpacity
      onPress={() => {
        setModalVisible(false);
      }}
    >
      <Modal
        animationType="fade"
        transparent={true}
        visible={modalVisible}
        onBackdropPress={() => setModalVisible(false)}
      >
        <View style={style.modalOutBackground}>
          <View style={{ display: "flex", height: "60%", width: "80%" }}>
            {PremiMultimedia(premi)}
            <Text style={style.textPerfil}>{premi["Nom" + idioma]}</Text>
          </View>
        </View>
      </Modal>
    </TouchableOpacity>
  );
}

export default PopUpPerfilImatge;
